var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigilocker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 10.3964V13.8333C2.8335 14.0101 2.90373 14.1797 3.02876 14.3047C3.15378 14.4298 3.32335 14.5 3.50016 14.5H12.5002C12.677 14.5 12.8465 14.4298 12.9716 14.3047C13.0966 14.1797 13.1668 14.0101 13.1668 13.8333V5.16667H10.1668C9.99002 5.16667 9.82045 5.09643 9.69542 4.9714C9.5704 4.84638 9.50016 4.67681 9.50016 4.5V1.5H3.50016C3.32335 1.5 3.15378 1.57024 3.02876 1.69526C2.90373 1.82029 2.8335 1.98986 2.8335 2.16667V6.8783",
    stroke: "#00B3B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.5L13.1667 5.16667",
    stroke: "#00B3B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46576 7.30957C8.45163 7.30957 8.43796 7.31134 8.42393 7.31167C8.33906 6.81698 8.10161 6.36121 7.74482 6.00819C7.38803 5.65517 6.92976 5.42257 6.4342 5.34296C5.93863 5.26335 5.43058 5.34071 4.98117 5.56422C4.53176 5.78773 4.16351 6.14619 3.92796 6.5894C3.91346 6.58907 3.8994 6.5872 3.88483 6.5872C3.34078 6.5872 2.81902 6.80333 2.43432 7.18803C2.04962 7.57273 1.8335 8.09449 1.8335 8.63854C1.8335 9.18259 2.04962 9.70435 2.43432 10.089C2.81902 10.4737 3.34078 10.6899 3.88483 10.6899H8.46576C8.91402 10.6899 9.34391 10.5118 9.66088 10.1948C9.97784 9.87787 10.1559 9.44798 10.1559 8.99972C10.1559 8.55147 9.97784 8.12157 9.66088 7.80461C9.34391 7.48764 8.91402 7.30957 8.46576 7.30957Z",
    stroke: "#00B3B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigilocker);
export default __webpack_public_path__ + "static/media/digi locker.448ee0a60ea55743d4892dfc2b8d3a9d.svg";
export { ForwardRef as ReactComponent };